// extracted by mini-css-extract-plugin
module.exports = {"container":"e_3A","widget":"e_4A","title":"e_5A","msrp":"e_6A","separator":"e_7A","textBadge":"e_8A"};